import { useGetFileByDocId } from "@/api/file";
import { useAuth } from "@/context/auth/AuthContext";
import { useVisibleT } from "@/lib/cms/cms-new-i18n";

/**
 * Aperçu canvas du bloc PdfReader : iframe si le PDF a une URL publique,
 * sinon placeholder informatif.
 */
export function PdfReaderBlockPreview({
  fileId,
  title,
  height,
}: {
  fileId: string | null;
  title?: string;
  height?: number;
}) {
  const vt = useVisibleT();
  const { instanceData } = useAuth();
  const cmsId = instanceData?.CMS?.id ?? "";
  const { data } = useGetFileByDocId(cmsId, undefined, { page: 0, pageSize: 500 });
  const h = height && height > 0 ? height : 720;
  const file = (data?.items as Array<{ id: string; title?: string; publicUrl?: string }> | undefined)?.find(
    (f) => f.id === fileId,
  );

  return (
    <div className="mx-auto w-full max-w-4xl">
      {title ? <h3 className="mb-3 text-lg font-semibold">{title}</h3> : null}
      {file?.publicUrl ? (
        <iframe
          title={file.title ?? title ?? "PDF"}
          src={file.publicUrl}
          className="w-full rounded border border-slate-200 bg-white"
          style={{ height: h }}
        />
      ) : (
        <div
          className="flex flex-col items-center justify-center gap-1 rounded border border-dashed border-slate-300 bg-slate-50 text-center text-sm text-slate-500"
          style={{ height: h }}
        >
          <span className="text-2xl">📄</span>
          <span>
            {fileId
              ? file
                ? vt(
                    "cms.new.preview.pdfReader.noPublicUrl",
                    "PDF sans URL publique — aperçu sur le site publié",
                  )
                : vt("cms.new.preview.pdfReader.loading", "Chargement du document…")
              : vt("cms.new.preview.pdfReader.empty", "Aucun PDF sélectionné")}
          </span>
        </div>
      )}
    </div>
  );
}
